import { Col, Grid, Row, Thumbnail } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'
import { getWorkflowImage } from '../../../../api/ispyb.js'

export default class WorkflowDataCollectionGroupPanel extends React.Component {
  getWorkflowsData() {
    /** To arrays */
    const workflows = []
    try {
      const ids = this.props.datacollectiongroup.workflowStepIds.split(',')
      const type = this.props.datacollectiongroup.workflowStepTypes.split(',')
      const status = this.props.datacollectiongroup.workflowStepStatuses.split(',')
      for (let i = 0; i < ids.length; i++) {
        workflows.push({
          id: ids[i],
          type: type[i],
          status: status[i],
        })
      }
    } catch (e) {
      alert('Error parsing workflow data : ', e) // eslint-disable-line no-alert
    }
    return workflows
  }

  render() {
    if (this.props.datacollectiongroup.workflowId) {
      const url = '/sessions/mx/proposal/:proposal/session/:sessionId/workflow/:workflowId/steps/:workflowStepIds'
        .replace(':token', this.props.token)
        .replace(':proposal', this.props.proposal)
        .replace(':sessionId', this.props.sessionId)
        .replace(':workflowId', this.props.datacollectiongroup.workflowId)
        .replace(':workflowStepIds', this.props.datacollectiongroup.workflowStepIds)

      const workflows = this.getWorkflowsData()

      return (
        <Grid fluid>
          <Row>
            {workflows.map(value => (
              <Col key={value.id} sm={12} md={2} lg={1}>
                <Thumbnail
                  style={{ width: '150px' }}
                  src={getWorkflowImage(this.props.user, this.props.proposal, value.id)}
                  alt="242x200"
                >
                  <h4>
                    <a href={url} target="_blank" rel="noreferrer">
                      {value.type}
                    </a>
                  </h4>
                  <p>{value.status}</p>
                  <p />
                </Thumbnail>
              </Col>
            ))}
          </Row>
        </Grid>
      )
    }
    return null
  }
}

WorkflowDataCollectionGroupPanel.propTypes = {
  user: PropTypes.object,
  proposal: PropTypes.string,
  sessionId: PropTypes.string,
  workflowId: PropTypes.string,
  workflowStepIds: PropTypes.string,
  workflowStepTypes: PropTypes.string,
  workflowStepStatuses: PropTypes.string,
}
